import React, { createContext, useRef, useEffect, useReducer, useCallback } from 'react';

export const LoadingIndicatorContext = createContext({});

export const LoadingIndicatorProvider = ({ children }) => {
  const isMounted = useRef(false);

  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);

  const [state, dispatch] = useReducer((state, action) => {
    switch (action.type) {
      case 'SET_LOADING':
        return { loading: action.payload }    
      default:
        return state;
    }
  }, { loading: false });

  const setLoading = useCallback(
    (loading) => {
      if (!!isMounted.current) {
        dispatch({ type:  'SET_LOADING', payload: loading })
      }
    },
    [],
  );

  const loadingIndicatorBag = {
    loading: state.loading,
    setLoading
  }

  return (
    <LoadingIndicatorContext.Provider value={loadingIndicatorBag}>
      { children }
    </LoadingIndicatorContext.Provider>
  );
}